export default "__VITE_ASSET__DxUnCFcy__"